import { CalculatorIcon, ClipboardCheckIcon, LinkIcon, ScanSearchIcon, WorkflowIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  value: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Fluid Power Symbols Decoder (ISO 1219)',
    description: 'Read any hydraulic or pneumatic schematic with confidence.',
    value: 'USD 14',
    icon: WorkflowIcon,
  },
  {
    number: '02',
    title: 'Hydraulic Troubleshooting Field Guide',
    description: 'From symptom to cause with structured checks.',
    value: 'USD 14',
    icon: ScanSearchIcon,
  },
  {
    number: '03',
    title: 'Hydraulic & Pneumatic Inspection Checklists',
    description: 'Daily, weekly, monthly and annual checks.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '04',
    title: 'Fluid Power Formulas & Quick Calculations',
    description: 'Force, speed, flow, power and conversions with worked examples.',
    value: 'USD 14',
    icon: CalculatorIcon,
  },
  {
    number: '05',
    title: 'Hose, Fitting & Seal Selection Essentials',
    description: 'Choose and install the right part the first time.',
    value: 'USD 14',
    icon: LinkIcon,
  },
];
